function throttle(func, wait) {
  let timer;
  let lastTime = 0;
  return function(...args) {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    const now = Date.now();
    if (!lastTime || now - lastTime >= wait) {
      lastTime = now;
      func(...args);
    } else {
      timer = setTimeout(function() {
        lastTime = now;
        func(...args);
      }, wait);
    }
  };
}
export {
  throttle
};
//# sourceMappingURL=Throttle.js.map
